<svg
  width="16"
  height="16"
  viewBox="0 0 16 16">
  <use [attr.xlink:href]="'#'+insightType()"></use>
</svg>

{{ insightType() }}
